import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import ledger from './modules/ledger'
import batch from './modules/batch'
import je from './modules/je'
import ap from './modules/ap'
import ar from './modules/ar'
import bp from './modules/bp'
import pp from './modules/pp'
import po from './modules/po'
import bank from './modules/bank'
import period from './modules/period'
import account from './modules/account'
import accountgroup from './modules/accountGroup'
import vendor from './modules/vendor'
import production from './modules/production'
import company from './modules/company'
import transaction from './modules/transaction'
import line from './modules/line'
import pettycash from './modules/pettycash'
import check from './modules/check'
import checkrun from './modules/checkrun'
import bankrec from './modules/bankrec'
import address from './modules/address'
import city from './modules/city'
import state from './modules/state'
import set from './modules/set'
import series from './modules/series'
import sourcecode from './modules/sourcecode'
import location from './modules/location'
import insurance from './modules/insurance'
import freefield from './modules/freefield'
import taxcode from './modules/taxcode'
import budget from './modules/budget'
import asset from './modules/asset'
import currency from './modules/currency'
import country from './modules/country'
import ui from './modules/ui'
import cachedparam from './modules/cachedparam'
import budgetline from './modules/budgetline'
import filters from './modules/filters'
import fields from './modules/fields'
import headerForm from './modules/headerForm'
import showCode from './modules/showCode'
import accountBalances from './modules/accountBalances'
import search from './modules/search'
import salesrep from './modules/salesrep'
import customer from './modules/customer'
import billabletype from './modules/billabletype'
import billableitem from './modules/billableitem'
import markup from './modules/markup'
import actions from './modules/helpers/actions'
import getters from './modules/helpers/getters'
import payment from './modules/payment'
import searchResults from './modules/searchResults'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    ui,
    auth,
    ledger,
    batch,
    je,
    ap,
    ar,
    bp,
    pp,
    po,
    bank,
    period,
    account,
    vendor,
    production,
    company,
    transaction,
    line,
    pettycash,
    check,
    checkrun,
    bankrec,
    address,
    city,
    state,
    set,
    series,
    sourcecode,
    location,
    insurance,
    freefield,
    taxcode,
    budget,
    asset,
    currency,
    country,
    cachedparam,
    budgetline,
    filters,
    fields,
    showCode,
    headerForm,
    accountBalances,
    search,
    salesrep,
    customer,
    billabletype,
    billableitem,
    markup,
    actions,
    getters,
    payment,
    accountgroup,
    searchResults
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js